const UNIT_MAP = {
    pressure: 'bar',
    freeAirDelivery: 'm³/min', 
    motor: 'kW',
    measurement: 'mm',
    weight: 'kg'
};

export const formatTechnicalValue = (value: string, fieldType: string): string => {
    if (!value || value.trim() === '') return '';
    
    const unit = UNIT_MAP[fieldType];
    if (!unit) return value;
    
    const hasUnit = value.toLowerCase().includes(unit.toLowerCase());
    
    if (hasUnit) {
        return value;
    }
    
    return `${value.trim()} ${unit}`;
};

export const formatWorkingHours = (hours: string): string => {
    if (!hours || hours.trim() === '') return '';
    
    const cleanedHours = hours.replace(/[,.]00$/, '');
    
    return cleanedHours;
};
